import moment from "moment";
import { BREAD_CRUMBS_STEPS } from "../constants/constants";

export default {
  config: { received: false },
  isGlobalFetch: false,
  globalModal: {
    show: false,
    message: ""
  },
  globalNotification: {
    show: false,
    msg: "",
    type: "info"
  },
  clubUserLoggedIn: false,
  clubUserData: null,
  discountClubConfig: {},
  isClubPricesInterested: false,
  isMobileView: false,
  lang: "eng",
  viewDirection: "ltr",
  promoCode: "",
  isPromoCodeValid: false,
  isIE: false,
  isIOS: false,
  showAvailability: false,
  lowAvailabilityCount: 5,
  selectedHotelID: null,
  selectedRegionID: null,
  selectedCityCode: null,
  selectedDealID: null,
  regionResults: [],
  rooms: [],
  addons: {},
  addonImagesLookupTable: {},
  selectedAddonsGroup: {},
  addonsCurosselRoomNumber: 0,
  roomsGroupedByDescriptor: {},
  displayRoomId: "",
  selectedPaxId: 0,
  paxList: [],
  currencies: [],
  selectedCurrency: "",
  titles: {},
  hotelData: {},
  chainHotels: [],
  sortRatesByLowestPrice: true,
  checkinDate: "",
  checkoutDate: "",
  enableSinglePaxCartSkipping: false,
  singlePaxLoaded: true,
  ShowCancellationPolicy: true,
  searchDataTimestamp: new Date().getTime(),
  selectedOption: {},
  deals: [],
  deal: {},
  dealSearchResults: [],
  isDealMode: false,
  hasDealResults: false,
  dealSearchPerformed: false,
  selectedRoomCategory: "",
  isSearchboxModalOpen: false,
  contactUsSubmitingStatus: {
    loading: false,
    error: false,
    succeed: false
  },
  registrationSubmitingStatus: {
    loading: false,
    error: false,
    succeed: false
  },
  countries: [],
  selectedCountry: {},
  termsAndConditions: "",
  bookingRates: [],
  bookingRatesEnabled: false,
  isNoPayment: false,
  registrationData: {},
  payment: {},
  paymentFinished: false,
  activeBreadCrumb: BREAD_CRUMBS_STEPS.BOOK,
  showContactDetailsInRegistration: false,
  allwayShowInRoomUnderRoomDisplay: 2,
  showPricePerNightThumb: false,
  displayPriceWithoutTaxes: false,
  taxesPrecentage: null,
  excludedTaxAtHotel: [],
  registrationModel: {
    FirstName: {
      required: true,
      visible: true,
      validation: {
        minLength: "2"
      }
    },
    LastName: {
      required: true,
      visible: true,
      validation: {
        minLength: "2"
      }
    },
    Passport: {
      required: true,
      visible: true,
      validation: {}
    },
    Email: {
      required: true,
      visible: true,
      validation: {
        pattern: "^S+@S+$"
      }
    },
    PhoneNumber: {
      required: true,
      visible: true,
      validation: {
        pattern: "^[0-9-+()]{7,30}$"
      }
    },
    Address: {
      required: false,
      visible: true
    },
    City: {
      required: false,
      visible: true
    }
  },
  registrationModelContact: {
    ContactName: {
      required: false,
      visible: false
    },
    CompanyName: {
      required: false,
      visible: true
    },
    ContactEmail: {
      required: false,
      visible: false
    },
    ContactPhone: {
      required: false,
      visible: false
    },
    ContactAddress: {
      required: false,
      visible: false
    }
  },
  enableAddonsPopUp: false,
  enableAddonsRegistration: true,
  showHotDeal: true,
  lastMinuteDaysDeal: "14",
  ShowThumbnailDisplay: false,
  numRoomsToSwitchToThumnailDisplay: 20,
  propertyType: "Hotel",
  propertyTypePlural: "Hotels",
  newSearchPerformed: false,
  thumbanilDisplay: false,
  placeHolder: [],
  analyticsPlaceHolders: {},
  ShowViewExpandedByDefault: false,
  expandbleView: false,
  roomFilters: [],
  planFilters: [],
  hotelFilter: [],
  regionFilter: [],
  maxPriceRangeFilter: null,
  minPriceRangeFilter: null,
  userComments: null
};

export const __search_Data_For_Dev_Only__ = {
  //isIE: true,
  Lang: "heb",
  //SelectedHotelID: 10478,
  //SelectedRegionId: 299,
  //SelectedCityCode: "Eilat",
  // SelectedOption: {
  //   optionType: "Hotel",
  //   value: "299"
  // },
  //PromoCode: "shiri1234",
  Pax: [
    {
      id: 0,
      Adults: 2,
      Children: 0,
      Infants: 1
    },
    {
      id: 1,
      Adults: 2,
      Children: 0,
      Infants: 0
    }
    // {
    //   id: 2,
    //   Adults: 2,
    //   Children: 0,
    //   Infants: 0
    // }
  ],
  CheckIn: moment()
    .add(5, "day")
    .format("DD.MM.YYYY"),
  CheckOut: moment()
    .add(10, "day")
    .format("DD.MM.YYYY")
  // CheckIn: moment("2019-07-25").format("DD.MM.YYYY"),
  // CheckOut: moment("2019-07-27").format("DD.MM.YYYY")
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js